require('hospitalBooking');
require('signin');
require('profile');
require('main');
require('kiosk');



// WEBPACK FOOTER //
// ../config/application.js